import { HorizontalBar } from 'vue-chartjs';
import { ChartDataLabels } from 'chartjs-plugin-datalabels';

Chart.defaults.bar.defaultFontSize = 16;

export default {
  extends: HorizontalBar,
  props: ['data', 'options'],
  plugins: ['chart-data-labels'],
  components: { ChartDataLabels },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.data, {
      tooltips: {
        enabled: true
      },
      hover: {
        animationDuration: 0
      },
      scales: {
        legend: {
          display: true
        },
        xAxes: [{
          ticks: {
            fontSize: 16,
            min: 0, // it is for ignoring negative step.
            beginAtZero: true,
            callback: function (value, index, values) {
              if (Math.floor(value) === value) {
                return value;
              }
            },
            display: true, // this will remove only the label
          },
          scaleLabel: {
            display: true
          },
          gridLines: {
          },
          stacked: true
        }],
        yAxes: [{
          gridLines: {
            display: true,
            color: "#fff",
            zeroLineColor: "#fff",
            zeroLineWidth: 0
          },
          ticks: {
            fontSize: 16,
            display: false
          },
          stacked: true
        }]
      },
      responsive: true,
      plugins: {
        datalabels: {
          align: 0,
          anchor: 'middle',
          font: {
            size: 16
          },
          formatter: function (value) {
            if (value > 0) {
              return value + "%";
            } else {
              return "";
            }
          },
          offset: 0,
          padding: {
            left: 0,
          }
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Charts/StackedBarChartPdf.js